import { atom } from "recoil";
import { ListCommentTeamMemberMailItem } from "src/aws/customAPI";

export const listCommentState = atom<ListCommentTeamMemberMailItem[]>({
  key: "atoms/comment/listCommentState",
  default: [],
})